export default "__VITE_ASSET__BUEep0Sx__"